<!--
 * @Author: czj
 * @Date: 2025-03-31 17:03:44
 * @Description: 
 * @FilePath: \test-demo2\src\components\TableOfContents\index.vue
-->
<template>
  <div class="table-of-contents">
    <nav class="toc" @click.stop="handleClick">
      <ul class="toc-list">
        <TocItem v-for="section in treeData" :key="section.id" :section="section" :level="1" :active-id="activeId" />
      </ul>
    </nav>


    <div class="bottom_box"
      v-if="store.ticket && store.app_id && store.task_id && !taskStore.template_config.is_reanalysis">
      <span class="btn_box"
        :class="{'btn_box_active': taskStore.is_reanalysis,'btn_box_disabled': !formStore.all_process_forms || formStore.all_process_forms.length === 0}"
        @click="!formStore.all_process_forms || formStore.all_process_forms.length === 0 ? null : handleRestart()">
        一键重分析
      </span>
    </div>


    <!--  <div class="bottom_box" v-if="store.ticket && store.app_id && store.task_id">
      <button @click="console.log(formStore.all_process_forms)">输出流程参数</button>
      <span class="btn_box" :class="{ 'btn_box_active': taskStore.is_reanalysis }" @click="handleRestart">一键重分析</span>
    </div> -->
  </div>
</template>
<script setup>
  import { ref, defineProps, watch, onBeforeMount, onMounted, onBeforeUnmount, defineEmits, nextTick } from 'vue';
  import TocItem from './TocItem/index.vue';

  import { useStore } from "@/Store/index.js";
  import { useTaskStore, useFormStore } from "@/Store/task.js";

  const store = useStore();
  const taskStore = useTaskStore();
  const formStore = useFormStore();

  const emit = defineEmits([])
  const props = defineProps({
    sections: {
      type: Array,
      required: true
    }
  });

  const treeData = ref([]);

  const activeId = ref(null) // 当前高亮的目录 id
  let sectionTops = [] // 缓存所有 section 的 offsetTop
  async function updateSectionTops() {
    await nextTick()
    sectionTops = props.sections.map(item => {
      //:id="'section-' + item.id"
      // const el = document.getElementById(item.id)
      const el = document.getElementById(`section-${item.id}`);
      return {
        id: item.id,
        top: el ? el.offsetTop : 0
      }
    })
  }


  const extractNamesFromNestedArray = (arr) => { // 递归处理嵌套数组
    return arr.map(item => {
      // 复制当前层级的对象，只保留 name
      const newItem = { id: item.id, name: item.name, index: item.index };
      // 如果有 result 字段且是非空数组，递归处理 result
      if (Array.isArray(item.result) && item.result.length > 0) {
        newItem.result = extractNamesFromNestedArray(item.result);
      }
      return newItem;
    });
  };

  const handleRestart = () => {
    // 重置任务状态
    if (!taskStore.is_reanalysis) {
      taskStore.setIsReanalysis(true);
    } else {
      taskStore.setIsReanalysis(false);
    }
    /* 
        taskStore.setIsReanalysis(true); */

    //回滚到页面顶部
    window.scrollTo(0, 0);

  };

  const handleClick = function () {
    taskStore.setIsReanalysis(false);
    window.scrollTo(0, 0);
  };


  function onScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;


    for (let i = sectionTops.length - 1; i >= 0; i--) {
      if (scrollTop >= sectionTops[i].top - 100) {
        activeId.value = sectionTops[i].id
        break
      }
    }

    const offset = 100; // 阈值，可根据需求调整

    // 获取所有内容区块
    const allSections = document.querySelectorAll('[id^="section-"]');
    let currentId = null;

    // 从下往上找第一个超过滚动位置的 section
    for (let i = allSections.length - 1; i >= 0; i--) {
      const section = allSections[i];
      const rectTop = section.getBoundingClientRect().top + window.scrollY;
      if (scrollTop + offset >= rectTop) {
        currentId = section.id.replace('section-', '');
        break;
      }
    }

    // 先清除之前的高亮
    const prevActive = document.querySelector('.toc-link.active');
    if (prevActive) prevActive.classList.remove('active');

    // 给当前对应的 <a> 加高亮
    if (currentId) {
      const currentLink = document.getElementById('toLink' + currentId);
      if (currentLink) currentLink.classList.add('active');
    }
  }




  // 使用 watch 监听 props 的字段变化
  watch(() => props, (newData, oldData) => {
  });
  //组件即将挂载
  onBeforeMount(() => {
  });
  //组件已经挂载
  onMounted(async () => {
    const tree_data = extractNamesFromNestedArray(props.sections);
    console.log("格式化的目录数据", tree_data);
    treeData.value = tree_data;
    await updateSectionTops();
    window.addEventListener('scroll', onScroll);

    console.log("模板数据", taskStore.template_config);

  });

  //组件即将卸载
  onBeforeUnmount(() => {
    window.removeEventListener('scroll', onScroll)
  });
</script>
<style lang="scss" scoped>
  .table-of-contents {
    position: relative;

    /*  overflow-y: auto; */
    /*   padding-bottom: 200px; */
    background-color: #fff;
    border-radius: 12px;
    overflow: hidden;

    .bottom_box {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      max-width: 248px;
      height: 80px;
      border-top: 1px solid #B2B2B2;
      box-sizing: border-box;
      background-color: #fff;
      padding: 30px 0;
      padding-left: 20px;

      .btn_box {
        cursor: pointer;
        font-size: 18px;
      }

      .btn_box.btn_box_disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }
    }
  }

  /* 样式定义 */
  /*  .toc {
    padding: 16px;
    max-width: 300px;
    font-family: Arial, sans-serif;
    overflow-y: auto;
    max-height: 90vh;
    overflow-y: auto;
    padding-bottom: 100px;
    box-sizing: border-box;
  } */

  .toc {
    padding: 16px;
    max-width: 300px;
    font-family: Arial, sans-serif;
    max-height: 90vh;
    padding-bottom: 100px;
    box-sizing: border-box;
    overflow-y: hidden;
    scrollbar-gutter: stable;
    scrollbar-width: none;

    &:hover {
      overflow-y: auto;
      scrollbar-width: auto;
    }
  }


  .toc-list {
    list-style: none;
    padding-left: 0;
    margin: 0;
  }

  .btn_box_active {
    color: var(--el-color-primary) !important;
  }
</style>